import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import LandingPage from "./pages/LandingPage";
import Support from "./pages/support";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

// --- NEW LEARN IMPORTS ---
import LearnHub from "./pages/learn/LearnHub";
import LearnArticle from "./pages/learn/LearnArticle";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // State for the selected article in the Learn Hub
  const [selectedArticle, setSelectedArticle] = useState(null);

  const getInitialView = () => {
    const path = window.location.pathname;
    if (path === "/privacy") return "privacy";
    if (path === "/terms") return "terms";
    if (path === "/learn") return "learn"; 
    return "landing";
  };

  const [view, setView] = useState(getInitialView);

  // 🔐 Auth listener (UNCHANGED)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // 🌐 URL-based view detection
  useEffect(() => {
    const path = window.location.pathname;
    if (path === "/privacy") setView("privacy");
    if (path === "/terms") setView("terms");
    if (path === "/learn") setView("learn");
  }, []);

  // ⏳ Loading screen (UNCHANGED)
  if (loading) {
    return (
      <div style={{ background: "#000", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p style={{ color: "#38bdf8", fontFamily: "sans-serif" }}>Loading...</p>
      </div>
    );
  }

  // 📄 Legal pages
  if (view === "privacy") return <PrivacyPage onBack={() => setView("landing")} />;
  if (view === "terms") return <TermsPage onBack={() => setView("landing")} />;

  // 📚 Learn Hub View
  if (view === "learn") {
    return (
      <LearnHub 
        onBack={() => {
          setView("landing");
          window.history.pushState({}, "", "/");
        }} 
        onArticleClick={(article) => {
          setSelectedArticle(article);
          setView("article");
          window.scrollTo(0, 0);
        }} 
      />
    );
  }

  // 📖 Individual Article View
  if (view === "article") {
    return (
      <LearnArticle 
        article={selectedArticle} 
        onBack={() => setView("learn")} 
        onGetStarted={() => {
          setView("login");
          window.scrollTo(0, 0);
        }}
        // ADDED: Passing this function prevents the "onArticleClick is not a function" error
        onArticleClick={(article) => {
          setSelectedArticle(article);
          window.scrollTo(0, 0);
        }}
      />
    );
  }

  // 🔐 Authenticated users
  if (user) return <Dashboard />;

  // 🆘 Support Page
  if (view === "support") {
    return (
      <div style={{ position: "relative" }}>
        <button
          onClick={() => { setView("landing"); window.history.pushState({}, "", "/"); }}
          style={{ position: "absolute", top: "20px", left: "20px", zIndex: 100, background: "#1e293b", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer" }}
        >
          ← Back to Site
        </button>
        <Support />
      </div>
    );
  }

  // 🔑 Login Page
  if (view === "login") {
    return (
      <div style={{ position: "relative" }}>
        <button
          onClick={() => { setView("landing"); window.history.pushState({}, "", "/"); }}
          style={{ position: "absolute", top: "20px", left: "20px", zIndex: 100, background: "transparent", color: "#64748b", border: "1px solid #1e293b", padding: "8px 16px", borderRadius: "8px", cursor: "pointer" }}
        >
          Back
        </button>
        <Login onSupportClick={() => setView("support")} />
      </div>
    );
  }

  // 🌍 Landing Page (DEFAULT)
  return (
    <LandingPage
      onGetStarted={() => setView("login")}
      onSupportClick={() => setView("support")}
      onLearnClick={() => {
        setView("learn");
        window.history.pushState({}, "", "/learn");
      }}
      onPrivacyClick={() => {
        setView("privacy");
        window.history.pushState({}, "", "/privacy");
      }}
      onTermsClick={() => {
        setView("terms");
        window.history.pushState({}, "", "/terms");
      }}
    />
  );
}

export default App;